export default __webpack_public_path__ + "images/c4168ef83636921fe2916b569bcfaeb0.svg";